import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {SafeHtmlPipe} from './safe-html.pipe';
import {FileSizePipe} from './file-size.pipe';
import {TruncatePipe} from './truncate.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SafeHtmlPipe, FileSizePipe, TruncatePipe],
  exports:[SafeHtmlPipe,FileSizePipe,TruncatePipe],
  providers:[SafeHtmlPipe,FileSizePipe,TruncatePipe]
})
export class PipesModule {}
